import { useParams } from 'react-router'
import ModalCEFeatureValue from './ModalCEFeatureValue'
import { FeatureValueModelTypeExtended } from './types'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import TwinTable from '../../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { DeleteRow, EditRowNotLink } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import ModalDeleteFeatureValue from './ModalDeleteFeatureValue'

interface FeatureValuesProps extends ComponentWithPermissions { }

const FeatureValues: React.FC<FeatureValuesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('featuresValues', 'Valores de característica'),
        newText: t('newValue', 'Nuevo valor'),
    }

    return (
        <BaseScreenTable TableComponent={TableFeatureValues} CreateModalComponent={ModalCEFeatureValue} EditModalComponent={ModalCEFeatureValue} DeleteModalComponent={ModalDeleteFeatureValue} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableFeatureValuesProps extends TableComponentProps { }

const TableFeatureValues: React.FC<TableFeatureValuesProps> = ({ setTableInstance, userPermissions, setOpened }) => {
    const { t } = useTwinTranslation()
    const { FeatureId } = useParams()
    const extraWhereParams = { 'FeatureId': FeatureId ? parseInt(FeatureId) : null }
    const columns: ColumnTableSchema<FeatureValueModelTypeExtended> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 75
        },
        {
            id: 'name',
            dataKey: 'FeatureValueLangs.name',
            label: t('name', 'Nombre'),
            sortable: true,
            minWidth: 130,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable columns={columns} name='featuresValues' extraWhereParams={extraWhereParams} getDataFrom='/api/app/product/feature/featureValue/getFeatureValues' setTableInstance={setTableInstance} hideLoadFiltersButton={true} />
    )
}

export default FeatureValues